/**
 * Specifies if an error is a timeout error based on the error message it brings.
 * @param {Error} error - An Error object whose message will be inspected to check whether it's a timeout error or not.
 * @return {boolean} True if the received error is caused by a timeout, false in other case.
 */
export function isTimeoutError(error) {
  return error.message && error.message.indexOf("timeout") !== -1;
}
